class FilterLogic {
	constructor(options) {
		let defaultOptions = {
			allowMultiple: true,
			history: false,
			setQueryParams: false,
			changeListener: () => {},
		}

		this.options = Object.assign(defaultOptions, options)
		this.filterState

		this.bndOnFilterClick = this.onFilterClick.bind(this)
	}

	// -- Helpers -----------------------------------------

	/**
	 * Constructs a filter dataset which can be used to filter
	 * We need this kind of structure because we want to filter in groups
	 * So each group is compared with AND and each filter in a group is compared with OR
	 */
	buildfilterState() {
		let filters = []

		let groups = {}
		let labels = {}
		this.filterEls.forEach((filter) => {
			let groupCat = filter.getAttribute('data-filter-group')
			let filterCat = filter.getAttribute('data-filter')

			if (filterCat == '*') return

			if (!groups[groupCat]) {
				groups[groupCat] = []
			}

			if (!labels[groupCat]) {
				labels[groupCat] = {}
			}
			groups[groupCat].push(filterCat)
			labels[groupCat][filterCat] = filter.textContent
		})

		// create the filterstate
		for (let key of Object.keys(groups)) {
			let filterSetup = {
				group: key,
				filters: groups[key],
				active: [],
				labels: labels[key],
			}
			if (this.options.groupBehavior && this.options.groupBehavior[key]) {
				filterSetup.behavior = this.options.groupBehavior[key] || 'and' // Default to 'or'
			}
			filters.push(filterSetup)
		}

		return filters
	}

	storeState() {
		if (!this.options.history) return
		const queryParams = this.generateQueryParams()
		const baseState = history.state || {}
		history.replaceState({ ...baseState, filterState: this.filterState }, '', queryParams)
		// if (!this.options.history) {
		// 	window.location = queryParams
		// 	return
		// } else {
		// 	history.replaceState(
		// 		Object.assign(history.state, { filterState: this.filterState }),
		// 		'',
		// 		queryParams
		// 	)
		// }
	}

	activateFilter(group, filter, doTriggerChange = true) {
		let groupData = this.filterState.find((o) => o.group === group)
		// when allowMultiple is false, limit input to one filter
		if (!this.options.allowMultiple) groupData.active = []
		groupData.active.push(filter)
		this.storeState()

		if (doTriggerChange) this.triggerChange()
	}

	deactivateFilter(group, filter, doTriggerChange = true) {
		let groupData = this.filterState.find((o) => o.group === group)
		groupData.active.splice(groupData.active.indexOf(filter), 1)
		this.storeState()

		if (doTriggerChange) this.triggerChange()
	}

	deactivateGroup(group, doTriggerChange = true) {
		let groupData = this.filterState.find((o) => o.group === group)
		groupData.active = []
		this.storeState()

		if (doTriggerChange) this.triggerChange()
	}

	generateQueryParams() {
		if (!this.options.setQueryParams) {
			return
		}

		let queryString = window.location.href.split('#')[0]

		let filterParts = []
		let singleCategory = this.filterState.length === 1

		this.filterState.forEach((filterGroup) => {
			if (filterGroup.active.length > 0) {
				let filtersStr = filterGroup.active.join(',')
				if (singleCategory) {
					filterParts.push(`${filtersStr}`)
				} else {
					filterParts.push(`${filterGroup.group}=${filtersStr}`)
				}
			}
		})

		if (filterParts.length > 0) queryString = `#${filterParts.join('&')}`

		return queryString
		// window.location.hash = queryString

		// history.replaceState(filterState, '', queryString)
	}

	activateFilter(group, filter, doTriggerChange = true) {
		let groupData = this.filterState.find((o) => o.group === group)

		if (filter == '*') {
			groupData.active = []
		} else {
			if (groupData.active.indexOf(filter) < 0) {
				if (groupData.behavior === 'or') {
					groupData.active = [filter]
				} else {
					groupData.active.push(filter)
				}
			}
		}

		this.storeState()

		if (doTriggerChange) this.triggerChange()
	}

	toggleFilter(group, filter, doTriggerChange = true) {
		// find the groupData from the filterState
		let groupData = this.filterState.find((o) => o.group === group)

		if (filter == '*') {
			groupData.active = []
		} else {
			// when allowMultiple is false, limit input to one filter
			if (groupData.active.indexOf(filter) < 0) {
				if (!this.options.allowMultiple) groupData.active = []

				// if groupData.behavior is 'or', we can only have one active filter
				if (groupData.behavior === 'or') {
					groupData.active = [filter]
				} else {
					groupData.active.push(filter)
				}
			} else {
				groupData.active.splice(groupData.active.indexOf(filter), 1)
			}
		}

		this.storeState()

		if (doTriggerChange) this.triggerChange()
	}

	triggerChange(noAnimation) {
		this.options.changeListener(this.filterState, noAnimation)
	}

	onFilterClick(ev) {
		let group = ev.currentTarget.getAttribute('data-filter-group')
		let filter = ev.currentTarget.getAttribute('data-filter')
		this.toggleFilter(group, filter)
	}

	getFilterState() {
		return this.filterState
	}

	clear(doTriggerChange = true) {
		this.filterState.forEach((group) => {
			group.active = []
		})
		this.storeState()

		if (doTriggerChange) {
			this.triggerChange()
		}
	}

	loadUrlFilters() {
		if (!this.options.setQueryParams) return

		const hash = window.location.hash.slice(1)
		if (!hash) return

		const parts = hash.split('&').filter(Boolean)
		const singleGroup = this.filterState.length === 1

		parts.forEach((part) => {
			let groupKey
			let values

			if (singleGroup && !part.includes('=')) {
				groupKey = this.filterState[0].group
				values = part.split(',')
			} else {
				const [key, rawValues = ''] = part.split('=')
				if (!key || !rawValues) return
				groupKey = key
				values = rawValues.split(',')
			}

			const groupState = this.filterState.find((group) => group.group === groupKey)
			if (!groupState) return

			groupState.active = values.filter((value) => groupState.filters.includes(value))
		})

		this.triggerChange(true)
	}

	// loadUrlFilters() {
	// 	console.warn('need to fix load url fitlers')
	// 	var hash = location.hash.substr(1)
	// 	if (hash == '') return false
	// 	var filters = []
	// 	var rawSets = hash.split('&')

	// 	let getFilter = () => {}

	// 	if (rawSets.length > 1) {
	// 		rawSets.forEach((set) => {
	// 			let setSplit = set.split('=')
	// 			let setKey = setSplit[0]
	// 			if (setSplit[1] === '') return
	// 			let items = setSplit[1].split(',')
	// 			if (items.length > 0) {
	// 				filters.push({
	// 					group: setKey,
	// 					active: items.map((item) => `${item}`),
	// 				})
	// 			}
	// 		})
	// 	} else {
	// 		this.filterState[0].active.push(hash)
	// 		this.triggerChange(true)
	// 	}
	// }

	destroy() {
		this.unbindFilterEvents()
		// this.filterEls.forEach((filter) => {
		// 	filter.removeEventListener('click', this.onFilterClick.bind(this))
		// })
	}

	setupFilterEls() {
		this.filterEls = Array.from(this.options.container.querySelectorAll('[data-filter]'))
	}
	/**
	 * Event binding in a centralized way
	 * Ensures consistent event listeners after refresh
	 */
	bindFilterEvents() {
		this.filterEls.forEach((filter) => {
			filter.addEventListener('click', this.bndOnFilterClick)
		})
	}

	unbindFilterEvents() {
		this.filterEls.forEach((filter) => {
			filter.removeEventListener('click', this.bndOnFilterClick)
		})
	}

	init() {
		this.setupFilterEls()
		const savedState = history.state?.filterState
		this.filterState = savedState || this.buildfilterState()

		// this.filterState = history.state.filterState || this.buildfilterState()
		// this.filterState = this.buildfilterState()

		if (this.options.activeByDefault) {
			this.filterState.forEach((group) => {
				group.active = group.filters
			})
		}

		this.loadUrlFilters()

		this.bindFilterEvents()

		// need to delay this a bit to ensure that the initial state is applied after init
		// might be a better way to do this
		setTimeout(() => {
			this.triggerChange(true)
		}, 0)

		// this.triggerChange()
	}
	refresh() {
		this.unbindFilterEvents()

		this.setupFilterEls()

		this.bindFilterEvents()
		// store a copy of the filter state
		let oldState = this.filterState
		// rebuild the filter state
		this.filterState = this.buildfilterState()
		// loop through the old state and apply the active filters to the new state
		// oldState.forEach((oldGroup) => {
		// 	let newGroup = this.filterState.find(
		// 		(group) => group.group === oldGroup.group
		// 	)
		// 	if (!newGroup) return
		// 	newGroup.active = oldGroup.active
		// })
		// // update this.filterState with the new filter state
		this.triggerChange(true)
	}
}

export default FilterLogic
